import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useResultsReviewProgress } from '@client/hooks/useResultsReviewProgress';

import { SessionType } from '@shared';
import { selectClient, selectInferenceSet, selectSession } from '@/model';

import { ALGORITHMS_ERROR, ALGORITHMS_FINISHED_RUNNING } from '@client';

export function useResultsAreInSlide(clientId: string) {
  const client = useSelector(selectClient);
  const session = useSelector(selectSession);
  const inferenceSet = useSelector(selectInferenceSet);

  const isClientSession = session.sessionType === SessionType.client;
  const clientHasNoAccess = isClientSession && client?.hasAccessToResults !== true;

  const clientTags = client?.clientTags;
  const clientFirstName = client?.clientFirstName ?? '';
  const clientHasStartedLtc = client?.intakeSurvey?.clientHasStartedLtc;

  const hasAlgorithmFinishedTag = clientTags?.includes(ALGORITHMS_FINISHED_RUNNING) ?? false;
  const hasInferenceSet = !!inferenceSet;
  const isAlgorithmFinishedRunning = hasAlgorithmFinishedTag || hasInferenceSet;
  const hasAlgorithmError = clientTags?.includes(ALGORITHMS_ERROR) ?? false;

  const [retryCountdown, setRetryCountdown] = useState(30);

  useEffect(() => {
    if (isAlgorithmFinishedRunning || hasAlgorithmError) return;

    const interval = setInterval(() => {
      setRetryCountdown(prev => {
        if (prev <= 1) {
          window.location.reload();
          return 30;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isAlgorithmFinishedRunning, hasAlgorithmError]);

  useResultsReviewProgress({
    clientId,
    isAlgorithmFinishedRunning,
    hasAlgorithmError,
  });

  return {
    clientHasNoAccess,
    clientFirstName,
    clientHasStartedLtc,
    isAlgorithmFinishedRunning,
    hasAlgorithmError,
    retryCountdown,
    handleRefresh: () => window.location.reload(),
  };
}
